import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from './errors';
import { notify } from '@/shared/components/notify';

const shouldRetry = (failureCount: number, error: unknown) =>
  !(error instanceof ApiError && error.status >= 400 && error.status < 500) && failureCount < 2;

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => notify.error(error),
  }),
  mutationCache: new MutationCache({
    // forms handle 400 field errors themselves; everything else gets a snackbar
    onError: (error, _variables, _context, mutation) => {
      if (mutation.meta?.silent) return; // the form shows the error itself
      if (!(error instanceof ApiError && error.code === 'VALIDATION_FAILED')) notify.error(error);
    },
  }),
  defaultOptions: {
    queries: { staleTime: 30_000, retry: shouldRetry, refetchOnWindowFocus: false },
    mutations: { retry: false },
  },
});
